/* global TOKEN_TRANSIT_PASS_URL */

import PropTypes from 'prop-types';
import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Link from '@material-ui/core/Link';

const TokenTransitDeeplinkModal = ({onClose, onConfirm}) => {
  return (
    <Dialog open onClose={onClose}>
      <DialogTitle id="simple-dialog-title">Fare Required</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You can view fare costs in the Token Transit app.  After your ride is booked you'll
          be given the option to buy your ticket through Token Transit or pay with cash on vehicle.
          Please be aware you'll need to pay with one of these methods.
        </DialogContentText>
        <Link
          href={TOKEN_TRANSIT_PASS_URL}
          target="_blank"
          rel="noopener"
          variant="body1"
        >
          View fares on Token Transit
        </Link>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} color="primary" autoFocus>
          Book Ride
        </Button>
      </DialogActions>
    </Dialog>
  );
};

TokenTransitDeeplinkModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default TokenTransitDeeplinkModal;



// WEBPACK FOOTER //
// ./src/ondemand/components/TokenTransitDeeplinkModal.js